$('#pageSize').change(function(e) {
    let newCount = $('#pageSize').val();
    let currentUrl = window.location.href;
    if (currentUrl.match(/pageSize=(\d+|all)/)) {
        currentUrl = currentUrl.replace(/pageSize=(\d+|all)/, 'pageSize=' + newCount);
    } else if (currentUrl.match(/\?/)) {
        currentUrl += '&pageSize=' + newCount;
    } else {
        currentUrl += '?pageSize=' + newCount;
    }

    // reset to page 1 since different page size
    // will put currently displayed records on a different page anyway
    currentUrl = currentUrl.replace(/page=(\d+)/, 'page=1');

    window.location = currentUrl;
});
